(function ($) {
    var windowWidth = $(window).outerWidth();
    var filterClass = document.querySelector('.project-filter .filter-content');

    if (windowWidth < 767) {
        $('.filter-label').on('click', function() {
            $(filterClass).slideToggle();
            $(filterClass).toggleClass('active');
            $(this).toggleClass('active');
        });
    }
})(jQuery);